import { render, staticRenderFns } from "./MerchantDelegations.vue?vue&type=template&id=700e9497&scoped=true"
import script from "./MerchantDelegations.vue?vue&type=script&lang=js"
export * from "./MerchantDelegations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e9497",
  null
  
)

export default component.exports